var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"sm","centered":"","id":"loading-modal","no-close-on-backdrop":true,"hide-header":"","hide-footer":""}},[_c('div',{staticStyle:{"height":"100px"}},[_c('loading',{attrs:{"active":_vm.loading,"is-full-page":false,"loader":"dots"},on:{"update:active":function($event){_vm.loading=$event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }